import { defineMessages } from 'react-intl'

export default defineMessages({
  profileHeading: {
    id: 'hub.user.settings.profile.heading',
    defaultMessage: 'Your Profile',
  },
  profileBackgroundImage: {
    id: 'hub.user.settings.profile.background',
    defaultMessage: 'Profile Background',
  },
  avatarImage: {
    id: 'hub.user.settings.avatar.image',
    defaultMessage: 'Avatar Image',
  },
  filter: {
    id: 'hub.user.filter',
    defaultMessage: `Filter`,
  },
  currentPassword: {
    id: 'hub.user.current.password',
    defaultMessage: `Current Password`,
  },
  newPassword: {
    id: 'hub.user.new.password',
    defaultMessage: `New Password`,
  },
  confirmNewPassword: {
    id: 'hub.user.confirm.new.password',
    defaultMessage: `Confirm New Password`,
  },
  saveChanges: {
    id: 'hub.user.save.changes',
    defaultMessage: `Save Changes`,
  },
  design: {
    id: 'hub.settings.design',
    defaultMessage: 'Design',
  },
  collectionTags: {
    id: 'hub.settings.collection.tags',
    defaultMessage: 'Collection & Tags',
  },
  collectionAdded: {
    id: 'pkg.domain.hubs.collection.added',
    defaultMessage: 'Successfully added collection',
  },
  errorTogglingAllCollection: {
    id: 'error.toggling.All.collection',
    defaultMessage: 'Error toggling All collection',
  },
  successfullyToggledALLCollection: {
    id: 'successfuly.toggled.ALL.collection',
    defaultMessage: 'Successfully toggled ALL collection',
  },
  errorMakeCollectionDefault: {
    id: 'error.Make.Collection.Default',
    defaultMessage: 'Failed to set collection as default',
  },
  successfullyMakeCollectionDefault: {
    id: 'successfully.Make.Collection.Default',
    defaultMessage: 'Successfully set collection as default',
  },
  collectionCreateError: {
    id: 'pkg.domain.hubs.collection.create.error',
    defaultMessage: 'Could not add collection',
  },
  collectionReorderError: {
    id: 'pkg.domain.hubs.collection.reorder.error',
    defaultMessage: 'Could not reorder collections',
  },
  allCollectionDescription: {
    id: 'all.Collection.Description',
    defaultMessage:
      'Posts from every collection will be visible on the all page. The all page can be hidden but not reordered.',
  },
  callsToAction: {
    id: 'hub.settings.calls.to.action',
    defaultMessage: 'Calls to Action',
  },
  widgets: {
    id: 'hub.settings.widgets.widgets',
    defaultMessage: 'Widgets',
  },
  newWidget: {
    id: 'hub.settings.widgets.new',
    defaultMessage: 'New Widget',
  },
  integrations: {
    id: 'hub.settings.integrations',
    defaultMessage: 'Integrations',
  },
  profileVariables: {
    id: 'hub.settings.profileVariables',
    defaultMessage: 'Profile Variables',
  },
  memberData: {
    id: 'hub.settings.memberData',
    defaultMessage: 'Member Data',
  },
  memberDataManagement: {
    id: 'hub.settings.memberDataManagement',
    defaultMessage: 'Member Data Management',
  },
  profileVariablesNotFound: {
    id: 'hub.settings.profileVariables.notFound',
    defaultMessage: 'No Profile Variables are available for this hub',
  },
  selectPVTitle: {
    id: 'hub.settings.profileVariables.select.title',
    defaultMessage: 'Select Profile Variables',
  },
  selectProvider: {
    id: 'hub.settings.profileVariables.select.provider',
    defaultMessage: 'Select Provider',
  },
  addPVButtonLabel: {
    id: 'hub.settings.profileVariables.add',
    defaultMessage: 'Add',
  },
  editPVButtonLabel: {
    id: 'hub.settings.profileVariables.edit',
    defaultMessage: 'Manage Profile Variables',
  },
  addPVTitle: {
    id: 'hub.settings.profileVariables.add.title',
    defaultMessage: 'Add Profile Variables',
  },
  addPVSubtitle: {
    id: 'hub.settings.profileVariables.add.subtitle',
    defaultMessage:
      'Get started by customizing the data points that your members could view and/or update',
  },
  addPVLink: {
    id: 'hub.settings.profileVariables.add.link',
    defaultMessage: 'Find out more',
  },
  editPVLink: {
    id: 'hub.settings.profileVariables.edit.link',
    defaultMessage: 'What is a Profile Variable?',
  },
  readOnlyPVTooltip: {
    id: 'hub.settings.profileVariables.readOnly.tooltip',
    defaultMessage: '{name} cannot be edited by members.',
  },
  variableName: {
    id: 'hub.settings.variableName',
    defaultMessage: 'Variable Name',
  },
  memberFacingName: {
    id: 'hub.settings.memberFacingName',
    defaultMessage: 'Member facing name',
  },
  group: {
    id: 'hubs.group',
    defaultMessage: 'Group',
  },
  memberFacingNameTooltip: {
    id: 'hub.settings.memberFacingName.tooltip',
    defaultMessage:
      'This is the display name that will be visible to members for this profile variable.',
  },
  profileVariableFrequency: {
    id: 'hub.settings.profileVariableFrequency',
    defaultMessage: 'Change frequency',
  },
  frequencyUnlimited: {
    id: 'hub.settings.profileVariableFrequency.unlimited',
    defaultMessage: 'Unlimited',
  },
  frequencyHalfYear: {
    id: 'hub.settings.profileVariableFrequency.halfyear',
    defaultMessage: 'Every six months',
  },
  frequencyAnnually: {
    id: 'hub.settings.profileVariableFrequency.annually',
    defaultMessage: 'Annually',
  },
  frequencyChange: {
    id: 'hub.settings.profileVariableFrequency.change',
    defaultMessage:
      'This field can only be changed {frequency}. Please contact member support if you require further assistance',
  },
  frequencyTooltip: {
    id: 'hub.settings.profileVariableFrequency.tooltip',
    defaultMessage: 'This determines how often members can update this profile variable.',
  },
  profileVariableReadOnlyMemberTooltip: {
    id: 'hub.settings.profileVariable.readOnly.member.tooltip',
    defaultMessage:
      'This field cannot be changed. Please contact member support if you require further assistance',
  },
  profileVariableCategoryTooltip: {
    id: 'hub.settings.profileVariableCategory.tooltip',
    defaultMessage: 'Members will be able to filter profile variables per defined category.',
  },
  profileVariableReadOnlyTooltip: {
    id: 'hub.settings.profileVariable.readOnly.tooltip',
    defaultMessage:
      'This will display the data points to members without allowing them to change it. Members will be directed to contact member support for related inquiries.',
  },
  profileVariableReadOnly: {
    id: 'hub.settings.profileVariable.readOnly',
    defaultMessage: 'Read only',
  },
  profileVariableCategory: {
    id: 'hub.settings.profileVariableCategory',
    defaultMessage: 'Category',
  },
  newCategory: {
    id: 'hub.settings.newCategory',
    defaultMessage: 'New Category',
  },
  categoryUnique: {
    id: 'hub.update.profileVariableCategory.unique',
    defaultMessage: 'Your category should be a unique',
  },
  addCategory: {
    id: 'hub.settings.addCategory',
    defaultMessage: 'Add Category',
  },
  removeCategory: {
    id: 'hub.settings.removeCategory',
    defaultMessage: 'Remove Category?',
  },
  confirmRemoveCategory: {
    id: 'hub.settings.confirmRemoveCategory',
    defaultMessage:
      'Any Profile Variables under this category will have their category options reset to the empty default option. Profile variables will not be deleted.',
  },
  pvCover: {
    id: 'hub.settings.pvCover',
    defaultMessage: 'No available categories.',
  },
  profileVariableCategories: {
    id: 'hub.settings.profileVariableCategories',
    defaultMessage: 'Categories',
  },
  profileVariableToggleLabel: {
    id: 'hub.settings.profileVariableToggleLabel',
    defaultMessage: 'Options',
  },
  hubProfile: {
    id: 'hub.settings.profile',
    defaultMessage: 'Hub Profile',
  },
  hubSingleSignOn: {
    id: 'hub.settings.single.signon',
    defaultMessage: 'Hub Single Sign-on',
  },
  hubFeatureToggles: {
    id: 'hub.settings.feature.toggles',
    defaultMessage: 'Hub Feature Toggles',
  },
  customDomain: {
    id: 'hub.settings.custom.domain',
    defaultMessage: 'Custom Domain',
  },
  advanced: {
    id: 'hub.settings.advanced',
    defaultMessage: 'Advanced',
  },
  hubName: {
    id: 'hub.settings.hubName',
    defaultMessage: 'Hub Name',
  },
  visitUrl: {
    id: 'hub.settings.visitUrl',
    defaultMessage: 'Visit URL',
  },
  coverDescription: {
    id: 'hub.settings.coverDescription',
    defaultMessage: 'Cover Description',
  },

  hubDescriptionHint: {
    id: 'hub.settings.hub.description.hint',
    defaultMessage: "Adds a 'more' link to the end of your cover description",
  },
  hubExtendedDescription: {
    id: 'hub.settings.extended.description',
    defaultMessage: 'Extended Description',
  },
  hubExtendedDescriptionPlaceholder: {
    id: 'hub.settings.extended.description',
    defaultMessage: 'Extended Description...',
  },
  SAMLSSO: {
    id: 'hub.settings.saml.sso',
    defaultMessage: 'SAML SSO',
  },
  SAMLRuntimeErrors: {
    id: 'hub.settings.saml.runtime.errors',
    defaultMessage: 'Runtime errors',
  },
  SAMLAddButton: {
    id: 'hub.settings.saml.add',
    defaultMessage: 'Add SAML SSO',
  },
  OIDCSSO: {
    id: 'hub.settings.oidc.sso',
    defaultMessage: 'Open-ID Connect Single Sign-On',
  },
  OIDCAddButton: {
    id: 'hub.settings.oidc.add',
    defaultMessage: 'Add Open-ID Connect',
  },
  OIDCCreateError: {
    id: 'pkg.domain.hubs.oidc.create.error',
    defaultMessage: 'Could not add OIDC provider',
  },
  OIDCAdded: {
    id: 'pkg.domain.hubs.oidc.added',
    defaultMessage: 'Successfully added OIDC provider',
  },
  OIDCUpdateError: {
    id: 'pkg.domain.hubs.oidc.update.error',
    defaultMessage: 'Could not update OIDC provider',
  },
  OIDCUpdated: {
    id: 'pkg.domain.hubs.oidc.updated',
    defaultMessage: 'Successfully updated OIDC provider',
  },
  OIDCDeleteError: {
    id: 'pkg.domain.hubs.oidc.delete.error',
    defaultMessage: 'Could not delete OIDC provider',
  },
  OIDCDeleted: {
    id: 'pkg.domain.hubs.oidc.deleted',
    defaultMessage: 'Successfully deleted OIDC provider',
  },
  OIDCProviderName: {
    id: 'hub.settings.oidc.name',
    defaultMessage: 'OIDC Provider Name',
  },
  SingleSignOnRuntimeErrors: {
    id: 'hub.settings.single.sign.on.runtime.errors',
    defaultMessage: 'SAML SSO runtime errors',
  },
  SingleSignOnRuntimeErrorsDescription: {
    id: 'hub.settings.single.sign.on.runtime.errors.description',
    defaultMessage:
      'These are the most recent errors that have occurred while running this SAML SSO configuration.',
  },
  SingleSignOnNoRuntimeErrors: {
    id: 'hub.settings.single.sign.on.no.runtime.errors.found',
    defaultMessage: 'No runtime errors found',
  },
  SingleSignOnCustomizebuttonText: {
    id: 'hub.settings.single.sign.on.customize.button.text',
    defaultMessage: 'Customize button text',
  },
  customizableSignleSignOnbutton: {
    id: 'customizable.Signle.Sign',
    defaultMessage: 'Enable customizable Signle Sign-On button',
  },
  customizableSignleSignOnbuttonDescription: {
    id: 'customizable.Signle.Sign.Description',
    defaultMessage:
      'Enabling this feature surfaces a customizable button in the sign in view redirecting visitors to your identity provider.',
  },
  DeleteSingleSignOn: {
    id: 'hub.settings.delete.single.sign.on',
    defaultMessage: 'Delete SAML SSO Configuration',
  },
  ConfirmDeleteSingleSignOn: {
    id: 'hub.settings.confirmDelete.single.sign.on',
    defaultMessage: 'Are you sure you want to remove {provider} SAML SSO configuration?',
  },
  CustomSAMLtext: {
    id: 'session.SAML.custom.text',
    defaultMessage: `Sign in with {provider}`,
  },
  SAMLDescription: {
    id: 'hub.settings.saml.description',
    defaultMessage:
      "Turning on SAML Single-Sign-On is ideal for Voice of employee Hubs where the members of your insight community are employees of your organization. With SAML SSO your members will be able to access the Hub using your Organization's Identity Provider.",
  },
  SAMLadditionalOptions: {
    id: 'hub.settings.saml.additional.options',
    defaultMessage: 'Additional options',
  },
  SAMLProfilingQuestionnaire: {
    id: 'hub.settings.saml.profiling.questionnaire',
    defaultMessage: 'Link to a profiling questionnaire',
  },

  SAMLSSOWarning: {
    id: 'hub.settings.saml.warning',
    defaultMessage:
      'Note: Enabling SAML SSO will disable Join Now options and Email and Password Sign-In',
  },

  CopyFromYourIDP: {
    id: 'Copy.from.your.IDP',
    defaultMessage: 'Copy from your IDP',
  },
  ClientSecret: {
    id: 'Client.Secret',
    defaultMessage: 'Client Secret',
  },

  wellknownConfiguration: {
    id: 'wellknown.Configuration',
    defaultMessage: 'Use well-known configuration',
  },
  wellknownConfigurationURL: {
    id: 'wellknown.Configuration.URL',
    defaultMessage: 'Well-known configuration URL',
  },
  manualConfiguration: {
    id: 'manual.Configuration',
    defaultMessage: 'Use manual configuration',
  },
  AuthenticiationRequestURL: {
    id: 'Authenticiation.Request.URL',
    defaultMessage: 'Authentication request endpoint URL',
  },
  PublicKeyUrl: {
    id: 'Public.key.URL',
    defaultMessage: 'Public key URL',
  },
  IssuerUrl: {
    id: 'Issuer.URL',
    defaultMessage: 'Issuer URL',
  },
  UserinfoEndpointURL: {
    id: 'User.info.Endpoint.URL',
    defaultMessage: ' Userinfo endpoint URL',
  },
  RefreshTokenEndpointURL: {
    id: 'Refresh.Token.Endpoint.URL',
    defaultMessage: 'Refresh token endpoint URL',
  },
  RevokeTokenEndpointURL: {
    id: 'Revoke.Token.Endpoint.URL',
    defaultMessage: 'Revoke token endpoint URL',
  },
  OpenIDcallbackURL: {
    id: 'Open.ID.callback.URL',
    defaultMessage: 'Open-ID callback URL',
  },
  CopyOpenIDcallbackURL: {
    id: 'Copy.Open.ID.callback.URL',
    defaultMessage: 'Copied Open-ID callback URL',
  },
  ClientID: {
    id: 'client.ID',
    defaultMessage: 'Client ID',
  },
  OIDCDescription: {
    id: 'hub.settings.oidc.description',
    defaultMessage: 'Use Open-ID Connect to authenticate members into the Hub.',
  },
  hubSignInEnableEmailAndPasswordSignIn: {
    id: 'hub.settings.Enable.email.password.sign.option',
    defaultMessage: 'Enable email and password sign in option',
  },
  hubSignInHeading: {
    id: 'hub.settings.sign.in.heading',
    defaultMessage: 'Sign In / Sign Up Page',
  },
  hubSignInShortHeading: {
    id: 'hub.settings.sign.in.short.heading',
    defaultMessage: 'Sign In Page',
  },
  hubSignInSubheading: {
    id: 'hub.settings.sign.in.sub.heading',
    defaultMessage: 'This page will be displayed to members who are new to your community.',
  },
  hubSignInWelcomeTitle: {
    id: 'hub.settings.sign.in.welcome.title',
    defaultMessage: 'Welcome Title',
  },
  hubSignInWelcomeTitleEnterTitle: {
    id: 'hub.settings.sign.in.welcome.title.enter.title',
    defaultMessage: 'Enter Title',
  },
  hubSignInWelcomeMessage: {
    id: 'hub.settings.sign.in.welcome.message',
    defaultMessage: 'Welcome Message',
  },
  hubSignInWelcomeMessageEnterMessage: {
    id: 'hub.settings.sign.in.welcome.message.enter.message',
    defaultMessage: 'Enter Message',
  },
  hubJoinNowDescription: {
    id: 'hub.settings.sign.in.join.description',
    defaultMessage: 'Enabling this feature surfaces a "Join" button in the sign in view',
  },
  hubJoinNowTitle: {
    id: 'hub.settings.sign.in.join.title',
    defaultMessage: 'Enable JOIN NOW button',
  },
  hubJoinNowURLError: {
    id: 'hub.settings.sign.in.join.url.error',
    defaultMessage: 'Invalid URL',
  },
  hubJoinNowURLPlaceholder: {
    id: 'hub.settings.sign.in.join.url.placeholder',
    defaultMessage: 'Enter recruitment survey URL',
  },
  hubJoinNowURLLabel: {
    id: 'hub.settings.sign.in.join.url.label',
    defaultMessage: 'URL',
  },
  hubJoinNowURLEnterMessage: {
    id: 'hub.settings.sign.in.join.now.placeholder',
    defaultMessage: 'Enter Join Now URL',
  },
  hubSignInNonMemberMessage: {
    id: 'hub.settings.sign.in.non.member.message',
    defaultMessage: 'Display message for Non-Members',
  },
  hubSignInNonMemberDescription: {
    id: 'hub.settings.sign.in.non.member.description',
    defaultMessage: 'This message will be displayed when an authentification error occurs',
  },
  hubSignInNonMemberMessagePlaceholder: {
    id: 'hub.settings.sign.in.non.member.message.placeholder',
    defaultMessage:
      "We're unable to authenticate your social sign on identity at this time. Please try again later",
  },
  hubLoginLogoLabel: {
    id: 'hub.settings.sign.in.logo.label',
    defaultMessage:
      'The logo will appear at the top of the sign in dialog. We recommend using images that are a minimum of 90 pixels in height. We support JPEGs and PNGs.',
  },
  privacySettings: {
    id: 'hub.settings.privacy.settings',
    defaultMessage: 'Privacy Settings',
  },
  hub: {
    id: 'hub.settings.hub',
    defaultMessage: 'Hub',
  },
  publicHub: {
    id: 'hub.settings.public.hub',
    defaultMessage: 'Public Hub',
  },
  publicHubHint: {
    id: 'hub.settings.public.hub.hint',
    defaultMessage: 'Anyone can search and find this Hub.',
  },
  privateHub: {
    id: 'hub.settings.private.hub',
    defaultMessage: 'Private Hub',
  },
  privateHubHint: {
    id: 'hub.settings.private.hub.hint',
    defaultMessage:
      'Only invited users can view this Hub. Visible in organization hub listings and members of an organization may request to join.',
  },
  preview: {
    id: 'hub.settings.preview',
    defaultMessage: 'Preview',
  },
  domain: {
    id: 'hub.settings.domain',
    defaultMessage: 'Domain',
  },
  customDomainInstruction: {
    id: 'hub.settings.custom.domain.instructions',
    defaultMessage:
      "Ensure you've updated your domain DNS settings for the above host to point the CNAME to hub.pressly.com. Once you've done this, you'll be able to start viewing your Pressly hub on your own domain.",
  },
  hostPath: {
    id: 'hub.settings.host.path',
    defaultMessage: 'Host Path (optional)',
  },
  enable_reposts: {
    id: 'hub.settings.enable_reposts',
    defaultMessage: 'Hub-to-Hub Posting',
  },
  enable_reposts_hint: {
    id: 'hub.settings.enable_reposts.hint',
    defaultMessage: 'Allow reposting of content from this hub to other hubs',
  },
  allow_member_submissions: {
    id: 'hub.settings.allow_member_submissions',
    defaultMessage: 'Allow Member Post Submissions',
  },
  allow_member_submissions_hint: {
    id: 'hub.settings.allow_member_submissions.hint',
    defaultMessage: 'Allow Hub Members to submit content for approval by Owners and Moderators',
  },
  hide_members: {
    id: 'hub.settings.hide_members',
    defaultMessage: 'Hide Member tab',
  },
  csp_strict_mode: {
    id: 'hub.settings.csp_strict_mode',
    defaultMessage: 'Allow Custom JS Plugins',
  },
  csp_strict_mode_hint: {
    id: 'hub.settings.csp_strict_mode_hint',
    defaultMessage:
      'Use of code plugins and/or embedded third party content within posts might lead to unintended changes to your Hub. Alida will not be able to provide troubleshooting support. Additionally, when this setting is turned on, only content from approved social media sites is allowed to be embedded within Hub posts. The list included Facebook, X (formerly Twitter), Youtube and Instagram.',
  },
  hide_members_hint: {
    id: 'hub.settings.hide_members.hint',
    defaultMessage: 'Hide member tab.',
  },
  members_user_popup: {
    id: 'hub.settings.members_user_popup',
    defaultMessage: 'Enable user pop-up for members',
  },
  members_user_popup_hint: {
    id: 'hub.settings.members_user_popup.hint',
    defaultMessage:
      "Enable members (and collaborators) to see other members' personal information and selected profile variables",
  },
  hide_members_count: {
    id: 'hub.settings.hide_members_count',
    defaultMessage: 'Hide Member Count',
  },
  hide_members_count_hint: {
    id: 'hub.settings.hide_members_count.hint',
    defaultMessage: 'Hide member count from the hub cover',
  },
  share_original_source: {
    id: 'hub.settings.share_original_source',
    defaultMessage: 'Share/Link Original Source',
  },
  share_original_source_hint: {
    id: 'hub.settings.share_original_source.hint',
    defaultMessage: 'Post short URLs link to the original article source rather than your hub.',
  },
  hide_likers: {
    id: 'hub.settings.hide_likers',
    defaultMessage: 'Hide users that have liked a post',
  },
  hide_likers_hint: {
    id: 'hub.settings.hide_likers.hint',
    defaultMessage: 'Hide the username and avatars of the users that have liked posts',
  },
  disable_cookie_consent: {
    id: 'hub.settings.disable_cookie_consent',
    defaultMessage: 'Disable cookie pop-up',
  },
  disable_cookie_consent_hint: {
    id: 'hub.settings.disable_cookie_consent.hint',
    defaultMessage:
      'Disable cookie pop-up for all users in the hub. You can edit the display text for the website URL in order to link to any additional documentation as required. Messaging will appear as follows:',
  },
  enable_cookie_consent: {
    id: 'hub.settings.enable_cookie_consent',
    defaultMessage: 'Enable cookie pop-up',
  },
  enable_cookie_consent_hint: {
    id: 'hub.settings.enable_cookie_consent.hint',
    defaultMessage:
      'Enable cookie pop-up for all users in the hub. You can edit the display text for the website URL in order to link to any additional documentation as required. Messaging will appear as follows:',
  },
  enable_ccpa: {
    id: 'hub.settings.enable_ccpa_consent',
    defaultMessage: 'Enable CCPA opt out for this hub',
  },
  enable_ccpa_hint: {
    id: 'hub.settings.enable_ccpa_consent.hint',
    defaultMessage:
      'Enable CCPA opt out page for all users in the hub. You can edit the display text for the page description. Messaging will appear as follows:',
  },
  ccpa_link: {
    id: 'hub.settings.ccpa_link',
    defaultMessage: 'CCPA opt out page link',
  },
  ccpa_default_label_text: {
    id: 'hub.settings.ccpa_default_label_text',
    defaultMessage: 'CCPA opt out page description',
  },
  ccpa_terms: {
    id: 'hub.settings.ccpa_terms',
    defaultMessage: `Under the California Consumer Privacy Act, California residents have the right to direct a business not to sell their personal information to third parties. If you would like to exercise your right to opt-out of the sale of your personal information by us, please fill out all information requested in the form. We will use the information submitted on this form solely for the purposes of complying with your opt-out request. You are not required to create an account with us in order to exercise your right to opt-out, and you may also authorize another individual to fill out this form on your behalf. Once processed, your opt-out will be honored until such time as you decide to opt back in.

Please note that the opt-out listed on this page does not opt you out of anything else. If you would like to opt-out of the community, email or other services, please refer to our privacy policy for instructions.`,
  },
  ccpa_form_created: {
    id: 'hub.settings.ccpa_form_created',
    defaultMessage: 'CCPA record successfully created',
  },
  open_external_source: {
    id: 'hub.settings.open_external_source',
    defaultMessage: 'Open Original Source',
  },
  open_external_source_hint: {
    id: 'hub.settings.open_external_source.hint',
    defaultMessage:
      "Hub stream links to posts go to the original article (the post's short URL) rather than the post on your hub.",
  },
  disable_infinite_scroll: {
    id: 'hub.settings.disable_infinite_scroll',
    defaultMessage: 'Disable Infinite Scroll',
  },
  disable_infinite_scroll_hint: {
    id: 'hub.settings.disable_infinite_scroll.hint',
    defaultMessage:
      'Disable Infinite Scroll on Feed and Hub stream. Instead show a "Load More" button.',
  },
  hide_file_embeds: {
    id: 'hub.settings.hide_file_embeds',
    defaultMessage: 'Hide embedded document previews for uploaded files',
  },
  hide_file_embeds_hint: {
    id: 'hub.settings.hide_file_embeds.hint',
    defaultMessage: 'Prevent document embeds from showing on the spotlight layer.',
  },
  allow_email_updates: {
    id: 'hub.settings.allow_email_updates',
    defaultMessage: 'Allow email updates',
  },
  allow_email_updates_hint: {
    id: 'hub.settings.allow_email_updates.hint',
    defaultMessage: 'Allow members to update their email address.',
  },
  allow_members_sign_email_password: {
    id: 'hub.settings.allow_members_signin_email_password',
    defaultMessage: 'Allow members to sign in to the Hub using an email and password.',
  },
  disable_pressly_digest: {
    id: 'hub.settings.disable_pressly_digest',
    defaultMessage: 'Hide posts in Pressly digest emails',
  },
  disable_pressly_digest_hint: {
    id: 'hub.settings.disable_pressly_digest.hint',
    defaultMessage:
      'Prevent any posts from this hub appearing in Pressly digest emails. This avoids duplicate notifications if digest newsletters are enabled for this hub.',
  },
  open_new_tab: {
    id: 'hub.settings.open_new_tab',
    defaultMessage: 'Open Stream posts in new tab',
  },
  open_new_tab_hint: {
    id: 'hub.settings.open_new_tab.hint',
    defaultMessage: 'Hub stream links will open in a new tab.',
  },
  disable_subscriber_workflow: {
    id: 'hub.settings.disable_subscriber_workflow',
    defaultMessage: 'Disable subscriber workflow',
  },
  disable_subscriber_workflow_hint: {
    id: 'hub.settings.disable_subscriber_workflow.hint',
    defaultMessage:
      'Disables subscriber modal and call out elements for this hub. Shows a Join button instead of Subscribe button in hub cover.',
  },
  use_native_email_share: {
    id: 'hub.settings.use_native_email_share',
    defaultMessage: 'Use native email share',
  },
  use_native_email_share_hint: {
    id: 'hub.settings.use_native_email_share.hint',
    defaultMessage: "Use the client's native email share instead of Pressly's email modal.",
  },
  enable_org_post_search: {
    id: 'hub.settings.enable_org_post_search',
    defaultMessage: 'Enable Organization-wide search for this Hub.',
  },
  enable_org_post_search_hint: {
    id: 'hub.settings.enable_org_post_search.hint',
    defaultMessage:
      'When users search this Hub they will search content across the entire Organization that this Hub belongs to.',
  },
  disable_contributions: {
    id: 'hub.settings.disable_comments',
    defaultMessage: 'Disable comments and replies',
  },
  disable_contributions_hint: {
    id: 'hub.settings.disable_comments.hint',
    defaultMessage: 'Commenting and replying to posts on this hub will be disabled.',
  },
  groupMembers: {
    id: 'hubs.group.members',
    defaultMessage: `Members`,
  },
  collaborators: {
    id: 'hubs.collaborators',
    defaultMessage: 'Collaborators',
  },
  invites: {
    id: 'hubs.invites',
    defaultMessage: `Invites`,
  },
  hide_collaborators: {
    id: 'hub.settings.hide_collaborators',
    defaultMessage: 'Hide Collaborators',
  },
  hide_collaborators_hint: {
    id: 'hub.settings.hide_collaborators.hint',
    defaultMessage: 'Collaborators section will be hidden from Team page.',
  },
  purge_display_name_enabled: {
    id: 'hub.settings.purge_display_name_enabled',
    defaultMessage: 'Replace purged or deleted display name for members',
  },
  purge_display_name_enabled_hint: {
    id: 'hub.settings.purge_display_name_enabled.hint',
    defaultMessage:
      'Update all purged or deleted display names for posts, comments and replies (Only applicable if sensitive data is enabled).',
  },
  purge_display_name_validation_error: {
    id: 'hub.settings.purge_display_name_validation_error',
    defaultMessage: 'Purge display name needs to be between 5 and 50 characters',
  },
  display_name: {
    id: 'hub.settings.display_name',
    defaultMessage: 'Require Display Name and PII Consent',
  },
  display_name_hint: {
    id: 'hub.settings.display_name.hint',
    defaultMessage:
      'Require all the new and existing Hub members to set or confirm their display name and profile variables. Messaging will appear as follows:',
  },
  enableSignupConfirmPageCustomDestination: {
    id: 'hub.settings.enable_signup_confirm_page_custom_destination',
    defaultMessage: 'Enable Custom URL in the recruitment workflow',
  },
  enableSignupConfirmPageCustomDestination_hint: {
    id: 'hub.settings.signup_confirm_page_custom_destination.info',
    defaultMessage:
      'Set custom URL to navigate users after completion of confirmation page as part of recruitment workflow, when this option is selected users will no longer be redirected to the hub',
  },
  signupPageHeaderLogoCentered: {
    id: 'hub.settings.signup_page_header_logo_centered',
    defaultMessage: 'Center Signup Page Header Logo',
  },
  signupPageHeaderLogoCentered_hint: {
    id: 'hub.settings.signup_page_header_logo_centered.info',
    defaultMessage: 'Align Signup Page Header Logo Centrally (by default it is left aligned)',
  },
  enable_similar_content: {
    id: 'hub.settings.enable_similar_content',
    defaultMessage: 'Enable Similar Content',
  },
  enable_similar_content_hint: {
    id: 'hub.settings.enable_similar_content.hint',
    defaultMessage:
      'Finds similar content to display after each posts spotlight view rather than the next posts which appear in order.',
  },
  experimental: {
    id: 'hub.settings.experimental',
    defaultMessage: 'Experimental',
  },
  selectLanguage: {
    id: 'hub.settings.select.language',
    defaultMessage: 'Select Language',
  },
  cover: {
    id: 'hub.settings.design.cover',
    defaultMessage: 'Cover',
  },
  header: {
    id: 'hub.settings.design.header',
    defaultMessage: 'Header',
  },
  text: {
    id: 'hub.settings.design.text',
    defaultMessage: 'Text',
  },
  addons: {
    id: 'hub.settings.design.addons',
    defaultMessage: 'Add-Ons',
  },
  coverPreview: {
    id: 'hub.settings.design.cover.preview',
    defaultMessage: 'Cover Preview',
  },
  hubLogo: {
    id: 'hub.settings.design.hub.logo',
    defaultMessage: 'Hub Logo',
  },
  hubLogoHint: {
    id: 'hub.settings.design.hub.logo.hint',
    defaultMessage:
      'This logo will appear on the cover at the top of your hub. We support transparent PNGs',
  },
  coverImage: {
    id: 'hub.settings.design.cover.image',
    defaultMessage: 'Cover Image',
  },
  coverImageHint: {
    id: 'hub.settings.design.cover.image.hint',
    defaultMessage: 'The cover image will appear on top of your hub. We support transparent PNGs',
  },
  coverOverlay: {
    id: 'hub.settings.design.cover.overlay',
    defaultMessage: 'Cover Overlay',
  },
  coverOverlayHint: {
    id: 'hub.settings.design.cover.overlay.hint',
    defaultMessage:
      'The Cover Overlay will be applied on your cover image. Cover Overlay does not apply to Hub Logos.',
  },
  tintColor: {
    id: 'hub.settings.design.cover.tint.color',
    defaultMessage: 'Tint Color',
  },
  tintOpacity: {
    id: 'hub.settings.design.cover.tint.opacity',
    defaultMessage: 'Tint Opacity',
  },
  colors: {
    id: 'hub.settings.design.colors',
    defaultMessage: 'Colors',
  },
  backgroundColor: {
    id: 'hub.settings.design.colors.background',
    defaultMessage: 'Background Color',
  },
  textColor: {
    id: 'hub.settings.design.colors.text',
    defaultMessage: 'Text Color',
  },
  iconColor: {
    id: 'hub.settings.design.colors.icon',
    defaultMessage: 'Icon Color',
  },
  others: {
    id: 'hub.settings.design.others',
    defaultMessage: 'Others',
  },
  showHubTitle: {
    id: 'hub.settings.design.others.showHubTitle',
    defaultMessage: 'Show Hub Title',
  },
  showHubTitleHint: {
    id: 'hub.settings.design.others.showHubTitleHint',
    defaultMessage: 'Shows the title in the hub cover',
  },
  hideCover: {
    id: 'hub.settings.design.others.hideCover',
    defaultMessage: 'Hide cover',
  },
  hideCoverHint: {
    id: 'hub.settings.design.others.hideCoverHint',
    defaultMessage: 'Optionally hide the hub cover for a more condensed layout',
  },
  leftAlignCover: {
    id: 'hub.settings.design.others.leftAlignCover',
    defaultMessage: 'Left-align Cover',
  },
  leftAlignCoverHint: {
    id: 'hub.settings.design.others.leftAlignCoverHint',
    defaultMessage: 'A different look for the cover',
  },
  headerPreview: {
    id: 'hub.settings.design.header.preview',
    defaultMessage: 'Header Preview',
  },
  headerLogo: {
    id: 'hub.settings.design.header.logo',
    defaultMessage: 'Header Logo',
  },
  headerLogoHint: {
    id: 'hub.settings.design.header.logo.hint',
    defaultMessage: 'This is a smaller logo you can choose to place on the header.',
  },
  headerBackground: {
    id: 'hub.settings.design.header.background',
    defaultMessage: 'Header Background',
  },
  headerBackgroundHint: {
    id: 'hub.settings.design.header.background.hint',
    defaultMessage:
      'You can choose a background color and opacity for your header, this will fade in as your scroll.',
  },
  centerHeaderLogo: {
    id: 'hub.settings.design.header.center.logo',
    defaultMessage: 'Center header logo?',
  },
  byLineText: {
    id: 'hub.settings.design.text.byline.text',
    defaultMessage: 'Byline Text',
  },
  byLineColor: {
    id: 'hub.settings.design.text.byline.color',
    defaultMessage: 'Byline Color',
  },
  headingText: {
    id: 'hub.settings.design.text.heading.text',
    defaultMessage: 'Heading Text',
  },
  headingColor: {
    id: 'hub.settings.design.text.heading.color',
    defaultMessage: 'Heading Color',
  },
  bodyText: {
    id: 'hub.settings.design.text.body.text',
    defaultMessage: 'Body Text',
  },
  bodyColor: {
    id: 'hub.settings.design.text.body.color',
    defaultMessage: 'Body Color',
  },
  linkColor: {
    id: 'hub.settings.design.text.link.color',
    defaultMessage: 'Link Color',
  },
  tileColor: {
    id: 'hub.settings.design.text.tile.color',
    defaultMessage: 'Tile Color',
  },
  accentColor: {
    id: 'hub.settings.design.text.accent.color',
    defaultMessage: 'Accent Color',
  },
  collectionsMenu: {
    id: 'hub.settings.design.collections.menu',
    defaultMessage: 'Collections Menu',
  },
  fontColor: {
    id: 'hub.settings.design.font.color',
    defaultMessage: 'Font Color',
  },
  footer: {
    id: 'hub.settings.design.footer',
    defaultMessage: 'Footer',
  },
  addon_customcss: {
    id: 'hub.settings.addons.custom_css',
    defaultMessage: 'Custom CSS',
  },
  addon_customcss_placeholder: {
    id: 'hub.settings.addons.custom_css_placeholder',
    defaultMessage: 'Enter custom CSS',
  },
  addon_customjavascript: {
    id: 'hub.settings.addons.custom_js',
    defaultMessage: 'Custom Javascript',
  },
  addon_customjavascript_placeholder: {
    id: 'hub.settings.addons.custom_js_placeholder',
    defaultMessage: 'Enter custom JavaScript',
  },
  addon_favicon: {
    id: 'hub.settings.addons.favicon',
    defaultMessage: 'Favicon',
  },
  addon_favicon_placeholder: {
    id: 'hub.settings.addons.favicon_placeholder',
    defaultMessage: 'Enter custom favicon URL',
  },
  addon_metaheader: {
    id: 'hub.settings.addons.meta.header',
    defaultMessage: 'Meta Header',
  },
  addon_injecthtmlcss: {
    id: 'hub.settings.addons.inject_html_css',
    defaultMessage: 'Custom HTML & CSS',
  },
  addon_injecthtmlcss_css: {
    id: 'hub.settings.addons.inject_html_css.css',
    defaultMessage: 'CSS',
  },
  addon_injecthtmlcss_css_description: {
    id: 'hub.settings.addons.inject_html_css.css.description',
    defaultMessage: 'Include your CSS here without style tags',
  },
  addon_injecthtmlcss_html: {
    id: 'hub.settings.addons.inject_html_css.html',
    defaultMessage: 'HTML',
  },
  addon_injecthtmlcss_html_description: {
    id: 'hub.settings.addons.inject_html_css.html.description',
    defaultMessage: 'Add your HTML here excluding script and link tags',
  },
  addon_injecthtmlcss_extension_point: {
    id: 'hub.settings.addons.inject_html_css.extension_point',
    defaultMessage: 'Extension Point',
  },
  addon_injecthtmlcss_extension_point_placeholder: {
    id: 'hub.settings.addons.inject_html_css.extension_point.placeholder',
    defaultMessage: 'Select an Extension Point',
  },
  addon_injecthtmlcss_css_placeholder: {
    id: 'hub.settings.addons.custom_inject_html_css_css_placeholder',
    defaultMessage: 'Enter custom CSS',
  },
  addon_injecthtmlcss_html_placeholder: {
    id: 'hub.settings.addons.custom_inject_html_css_html_placeholder',
    defaultMessage: 'Enter custom HTML',
  },
  size: {
    id: 'hub.settings.size',
    defaultMessage: 'Size',
  },
  sizePlaceholder: {
    id: 'hub.settings.size.placeholder',
    defaultMessage: 'Size in pixels... e.g. 16',
  },
  attribute: {
    id: 'hub.settings.addons.meta.attribute',
    defaultMessage: 'Attribute',
  },
  selectAttributeType: {
    id: 'hub.settings.addons.meta.attribute.select.type',
    defaultMessage: 'Select Attribute type',
  },
  attributeValue: {
    id: 'hub.settings.addons.meta.attribute.value',
    defaultMessage: 'Attribute Value',
  },
  makeHomepage: {
    id: 'hub.settings.collections.makeHomepage',
    defaultMessage: 'Make homepage',
  },
  showAllPage: {
    id: 'hub.settings.collections.showAllPage',
    defaultMessage: 'Show all page',
  },
  hideAllPage: {
    id: 'hub.settings.collections.hideAllPage',
    defaultMessage: 'Hide all page',
  },
  collectionTagsSubhead: {
    id: 'hub.settings.collections.tags.subhect',
    defaultMessage: 'Collections will display in the order set below.',
  },
  addNewCollection: {
    id: 'hub.settings.collections.tags.new.collection',
    defaultMessage: 'New Collection',
  },
  collectionName: {
    id: 'hub.settings.collections.tags.collection.name',
    defaultMessage: 'Collection Name',
  },
  deleteCollection: {
    id: 'hub.settings.collections.tags.delete.collection',
    defaultMessage: 'Delete Collection',
  },
  collectionDeleteConfirm: {
    id: 'hub.settings.collections.tags.delete.collection.confirm',
    defaultMessage: 'Are you sure you want to remove "{collectionName}"?',
  },
  collectionDeleted: {
    id: 'hub.settings.collections.tags.deleted',
    defaultMessage: 'Successfully deleted collection',
  },
  collectionDeleteError: {
    id: 'hub.settings.collections.tags.delete.error',
    defaultMessage: 'Failed to delete collection',
  },
  collectionArchiveConfirm: {
    id: 'hub.settings.collections.tags.archive.collection.confirm',
    defaultMessage:
      'Are you sure you want to archive this collection? Posts that are only on this collection will no longer be visible.',
  },
  collectionArchived: {
    id: 'hub.settings.collections.tags.archived',
    defaultMessage: 'Successfully archived collection',
  },
  collectionArchiveError: {
    id: 'hub.settings.collections.tags.archive.error',
    defaultMessage: 'Failed to archive collection',
  },
  archiveCollection: {
    id: 'hub.settings.collections.tags.archive.collection',
    defaultMessage: 'Archive Collection',
  },
  collectionRestoreConfirm: {
    id: 'hub.settings.collections.tags.restore.collection.confirm',
    defaultMessage:
      'Are you sure you want to restore this collection? Posts that are on this collection will be visible.',
  },
  collectionRestored: {
    id: 'hub.settings.collections.tags.restored',
    defaultMessage: 'Successfully restored collection',
  },
  collectionRestoreError: {
    id: 'hub.settings.collections.tags.restore.error',
    defaultMessage: 'Failed to restore collection',
  },
  restoreCollection: {
    id: 'hub.settings.collections.tags.restore.collection',
    defaultMessage: 'Restore Collection',
  },
  removeCollection: {
    id: 'hub.settings.collections.tags.remove.collection',
    defaultMessage: 'Remove Collection',
  },
  collectionSaved: {
    id: 'hub.settings.collections.saved',
    defaultMessage: 'Successfully saved collection',
  },
  collectionSaveError: {
    id: 'hub.settings.collections.save.error',
    defaultMessage: 'Failed to save collection',
  },
  fetchCollectionError: {
    id: 'hub.settings.collections.save.error',
    defaultMessage: 'Failed to display the collection',
  },
  emptyTagsMessage: {
    id: 'hub.settings.collections.tags.empty',
    defaultMessage: 'This collection has no tags.',
  },
  callToAction: {
    id: 'hub.settings.call.to.actions',
    defaultMessage: '{count, plural, one {Call To Action} other {Calls To Action}}',
  },
  newQuickPoll: {
    id: 'hub.settings.call.to.actions.newQuickPoll',
    defaultMessage: 'New Quick Poll',
  },
  buildQuickPoll: {
    id: 'hub.settings.widget.buildQuickPoll',
    defaultMessage: 'Build Quick Poll',
  },
  widgetName: {
    id: 'hub.settings.widget.name',
    defaultMessage: 'Widget Name',
  },
  quickPollName: {
    id: 'hub.settings.widget.quickPoll.name',
    defaultMessage: 'Quick Poll Name',
  },
  placement: {
    id: 'hub.settings.cta.widget.placement',
    defaultMessage: 'Placement',
  },
  manual: {
    id: 'hub.settings.cta.widget.manual',
    defaultMessage: 'Manual',
  },
  manualHint: {
    id: 'hub.settings.cta.widget.manual.hint',
    defaultMessage:
      'You must manually insert this widget into your posts via the Composer "Add Widget". The widget will not be automatically placed.',
  },
  streamHint: {
    id: 'hub.settings.cta.widget.stream.hint',
    defaultMessage:
      'The widget will appear on the Stream layer of your hub. The widget will be repeated based on frequency and offset set below.',
  },
  postHint: {
    id: 'hub.settings.cta.widget.post.hint',
    defaultMessage:
      'The widget will appear on the Post layer. The widget will appear on each post.',
  },
  sizeType: {
    id: 'hub.settings.cta.widget.size.type',
    defaultMessage: 'Size & Type',
  },
  selectSize: {
    id: 'hub.settings.cta.widget.select.size',
    defaultMessage: 'Select Size',
  },
  height: {
    id: 'hub.settings.cta.widget.height',
    defaultMessage: 'Height',
  },
  selectType: {
    id: 'hub.settings.cta.widget.select.type',
    defaultMessage: 'Select Type',
  },
  allCollections: {
    id: 'hub.settings.cta.widget.all.collections',
    defaultMessage: 'All Collections',
  },
  allCollectionsHint: {
    id: 'hub.settings.cta.widget.all.collections.hint',
    defaultMessage: 'Display in every collection.',
  },
  individualCollections: {
    id: 'hub.settings.cta.widget.individual.collections',
    defaultMessage: 'Individual Collections',
  },
  individualCollectionsHint: {
    id: 'hub.settings.cta.widget.individual.collections.hint',
    defaultMessage: 'Specify which collections the widget should be displayed in.',
  },
  streamFrequency: {
    id: 'hub.settings.cta.widget.stream.frequency',
    defaultMessage: 'Stream Frequency',
  },
  streamFrequencyTooltip: {
    id: 'hub.settings.widgets.stream.frequency.tooltip',
    defaultMessage: 'This will determine the placement of your widget.',
  },
  deleteWidget: {
    id: 'hub.settings.widgets.delete.widget',
    defaultMessage: 'Delete Widget',
  },
  deleteWidgetConfirm: {
    id: 'hub.settings.cta.widget.delete.widget.confirm',
    defaultMessage: 'Are you sure you want to remove "{widgetName}"?',
  },
  cta_type_img: {
    id: 'hub.settings.cta.widget.img',
    defaultMessage: 'Image Link',
  },
  cta_type_iframe: {
    id: 'hub.settings.cta.widget.iframe',
    defaultMessage: 'External URL',
  },
  cta_type_iframe_in_adtag: {
    id: 'hub.settings.cta.widget.iframe_in_adtag',
    defaultMessage: 'Custom HTML',
  },
  cta_type_subscribe: {
    id: 'hub.settings.cta.widget.subscribe',
    defaultMessage: 'Subscribe CTA',
  },
  cta_freq: {
    id: 'hub.settings.cta.widget.freq',
    defaultMessage: '{count, plural, one {Every Block} other {Every {count} blocks}}',
  },
  cta_freq_0: {
    id: 'hub.settings.cta.widget.freq.0',
    defaultMessage: 'Once',
  },
  cta_offset: {
    id: 'hub.settings.cta.widget.offset',
    defaultMessage: '{count, plural, one {After # block} other {After # blocks}}',
  },
  cta_offset_0: {
    id: 'hub.settings.cta.widget.offset.0',
    defaultMessage: 'Immediately',
  },
  imageUrl: {
    id: 'hub.settings.image.url',
    defaultMessage: 'Image URL',
  },
  linkTo: {
    id: 'hub.settings.link.to',
    defaultMessage: 'Link To',
  },
  html: {
    id: 'hub.settings.html',
    defaultMessage: 'HTML',
  },
  facebook_description: {
    id: 'hub.settings.integration.facebook_description',
    defaultMessage: 'Track conversions with the Facebook pixel.',
  },
  google_analytics_description: {
    id: 'hub.settings.integration.google_analytics_description',
    defaultMessage: 'Track events with your Google Analytics account.',
  },
  hubspot_description: {
    id: 'hub.settings.integration.hubspot_description',
    defaultMessage: 'Enable Hubspot tracking on your hub.',
  },
  intercom_description: {
    id: 'hub.settings.integration.intercom_description',
    defaultMessage: 'Engage directly with customers by using Intercom on your hub.',
  },
  marketo_munchkin_description: {
    id: 'hub.settings.integration.marketo_munchkin_description',
    defaultMessage: 'Track leads and page visits with a Marketo munchkin.',
  },
  twitter_universal_tag_description: {
    id: 'hub.settings.integration.twitter_universal_tag_description',
    defaultMessage: 'Track conversions with the Twitter pixel.',
  },
  zendesk_widget: {
    id: 'hub.settings.integration.zendesk_widget',
    defaultMessage: 'Zendesk Widget.',
  },
  zendesk_widget_description: {
    id: 'hub.settings.integration.zendesk_widget_description',
    defaultMessage: 'Zendesk Widget.',
  },
  addonLabel: {
    id: 'hub.settings.addon.label',
    defaultMessage: 'Addon Label',
  },
  facebookTrackingId: {
    id: 'hub.settings.addon.facebook.tracking.id',
    defaultMessage: 'Facebook Tracking ID',
  },
  gaTrackingId: {
    id: 'hub.settings.addon.ga.tracking.id',
    defaultMessage: 'GA Tracking ID',
  },
  gaVersion: {
    id: 'hub.settings.addon.ga.version',
    defaultMessage: 'GA Version',
  },
  gaClassic: {
    id: 'hub.settings.addon.ga.classic',
    defaultMessage: 'Classic',
  },
  gaUniversal: {
    id: 'hub.settings.addon.ga.universal',
    defaultMessage: 'Universal',
  },
  useCanonical: {
    id: 'hub.settings.addon.ga.use.canonical',
    defaultMessage: 'Use canonical URLs when tracking?',
  },
  trackingId: {
    id: 'hub.settings.addon.tracking.id',
    defaultMessage: 'Tracking ID',
  },
  hubspotTrackingId: {
    id: 'hub.settings.addon.hubspot.tracking.id',
    defaultMessage: 'Hubspot Tracking ID',
  },
  marketoTrackingId: {
    id: 'hub.settings.addon.marketo.tracking.id',
    defaultMessage: 'Marketo Tracking ID',
  },
  intercomAppId: {
    id: 'hub.settings.addon.intercom.app.id',
    defaultMessage: 'Intercom App ID',
  },
  twitterTrackingId: {
    id: 'hub.settings.addon.twitter.app.id',
    defaultMessage: 'Twitter Tracking ID',
  },
  teamId: {
    id: 'hub.settings.addon.team.id',
    defaultMessage: 'Team ID',
  },
  zendeskTrackingId: {
    id: 'hub.settings.addon.zendesk.team.id',
    defaultMessage: 'Zendesk Team ID',
  },
  pleaseSelectSomething: {
    id: 'hubs.settings.please.select',
    defaultMessage: `Please select something...`,
  },
  successfullySavedChanged: {
    id: 'hubs.settings.successfully.saved.changed',
    defaultMessage: 'Successfully saved changes',
  },
  failedToSaveChanges: {
    id: 'hubs.settings.failed.to.save.changes',
    defaultMessage: 'Failed to save changes',
  },
  successfullyCreatedIntegration: {
    id: 'hubs.settings.integrations.successfully.created',
    defaultMessage: 'Successfully added a new integration',
  },
  successfullyUpdatedIntegration: {
    id: 'hubs.settings.integrations.successfully.updated',
    defaultMessage: 'Successfully updated the integration',
  },
  successfullyRemovedIntegration: {
    id: 'hubs.settings.integrations.successfully.removed',
    defaultMessage: 'Successfully removed the integration',
  },
  ctaSizeFullScreen: {
    id: 'hubs.settings.ctas.size.fullscreen',
    defaultMessage: 'Fullscreen',
  },
  ctaSizeCustomHeight: {
    id: 'hubs.settings.ctas.size.custom.height',
    defaultMessage: 'Custom Height',
  },
  deleteAddon: {
    id: 'hubs.settings.delete.addon',
    defaultMessage: 'Delete Add-On',
  },
  removeAddon: {
    id: 'hubs.settings.remove.addon',
    defaultMessage: 'Remove Add-On',
  },
  confirmAddonRemoval: {
    id: 'hubs.settings.confirm.addon.removal',
    defaultMessage: `Are you sure you want to remove "{addon}"?`,
  },
  updateDisplayNameLabel: {
    id: 'settings.update.display.name.label',
    defaultMessage:
      'This will be your community facing name. The name will appear in your posts, comments and replies and will be used for tagging and mentioning',
  },
  updatePasswordLabel: {
    id: 'settings.update.password.label',
    defaultMessage: 'Your password should be a unique and secure way of signing in',
  },
  updateEmailLabel: {
    id: 'settings.update.email.label',
    defaultMessage:
      'Access your account by signing in with your email. It is also used to handle any communications and notifications',
  },
  ssoManageTitle: {
    id: 'settings.update.sso.title',
    defaultMessage: 'Social Accounts',
  },
  ssoManageLabel: {
    id: 'settings.update.sso.label',
    defaultMessage: 'Enable sign in with a social platform account to access your account.',
  },
  samlEnableButtonText: {
    id: 'settings.saml.enable.button',
    defaultMessage: 'Enable SSO button on the Sign-in page',
  },
  singleSignOnLabel: {
    id: 'settings.update.sso.label',
    defaultMessage: 'Single Sign-On label',
  },
  singleSignOnDescription: {
    id: 'settings.update.sso.description',
    defaultMessage:
      'In {provider}, create a new SAML 2.0 Connector then input the following values to connect your Hub to {provider}. Once completed paste the {provider} Metadata URL below.',
  },
  SignInWithSSO: {
    id: 'Sign.In.With.SSO',
    defaultMessage: 'Sign in with Single Sign-On',
  },

  PasteURL: {
    id: 'Paste.URL',
    defaultMessage: 'Paste URL',
  },
  singleSignOnAssertion: {
    id: 'settings.update.sso.assertion',
    defaultMessage: 'ASSERTION CONSUMER SERVICE URL:',
  },
  singleSignOnCopyUrl: {
    id: 'settings.update.sso.copyURL',
    defaultMessage: 'Copy URL',
  },
  singleSignOnAttributes: {
    id: 'settings.update.sso.attribute',
    defaultMessage: 'REQUIRED ATTRIBUTES',
  },
  singleSignOnWarning: {
    id: 'settings.update.sso.warning',
    defaultMessage:
      'Attributes are case sensitive. Please ensure that your SAML 2.0 Connector includes all of the required values. Do not include any additional values.',
  },
  singleSignOnMetaData: {
    id: 'settings.update.sso.MetaData',
    defaultMessage: 'Metadata URL',
  },
  singleSignOnIdpNote: {
    id: 'settings.update.sso.idp.note',
    defaultMessage: 'This URL should come from your Identity Provider',
  },
  singleSignOnInitiatedSignIn: {
    id: 'settings.update.sso.initiated.Signin',
    defaultMessage: 'SSO button URL (Identity Provider initiated Sign-In URL)',
  },
  samlButtonEnabled: {
    id: 'settings.saml.button.enabled',
    defaultMessage: 'Button enabled',
  },
  samlButtonDisabled: {
    id: 'settings.saml.button.disabled',
    defaultMessage: 'Button disabled',
  },
  oidcButtonEnabled: {
    id: 'settings.oidc.button.enabled',
    defaultMessage: 'Button enabled',
  },
  oidcButtonDisabled: {
    id: 'settings.oidc.button.disabled',
    defaultMessage: 'Button disabled',
  },
  singleSignOnHelpLink: {
    id: 'settings.update.sso.help.link',
    defaultMessage: '  More help can be found here.',
  },

  profileDataTitle: {
    id: 'settings.update.data.title',
    defaultMessage:
      'Ensure your information is up to date so we can tailor the content you receive to your interests',
  },
  profilePvAll: {
    id: 'hub.user.settings.profile.pv.all',
    defaultMessage: `All ({count})`,
  },
  ssoManageDisableTitle: {
    id: 'hub.user.settings.sso.send.email.title',
    defaultMessage: 'Remove {provider} Social Login',
  },
  ssoManageDisableMessage: {
    id: 'hub.user.settings.sso.disable.message',
    defaultMessage:
      'There are currently {membersCount} members who are connected through a {provider} account. Disabling this setting will send an email to the {membersCount} members notifying them of the changes.',
  },
  ssoManageDisableMemberMessage: {
    id: 'hub.user.settings.sso.member.disable.message',
    defaultMessage:
      'You are currently using {provider} as one of your sign in options. Removing this social platform could change your sign in experience.',
  },
  ssoManageSendEmailMessage: {
    id: 'hub.user.settings.sso.send.email.message',
    defaultMessage:
      'Optionally, you can choose to send them an email to notify them of the changes.',
  },
  ssoManageSendEmailCheckbox: {
    id: 'hub.user.settings.sso.send.email.checkbox',
    defaultMessage: 'Send email to members',
  },
  ssoManageHeading: {
    id: 'hub.user.settings.sso.title',
    defaultMessage: 'Social Sign-On',
  },
  ssoManageDescription: {
    id: 'hub.user.settings.sso.description',
    defaultMessage:
      'Turning on a Social login will enable users to authenticate with their social networking services. It is recommended to tailor these to social platforms which are widely used by your community.',
  },
  ssoMembersConnected: {
    id: 'hub.user.settings.sso.members.connected',
    defaultMessage: '{membersCount} Members connected',
  },
  next_signin_page: {
    id: 'hub.settings.customDomain.nextSigninPage',
    defaultMessage: 'Faster sign-in pages (Next.js SSR)',
  },
  next_signin_page_hint: {
    id: 'hub.settings.customDomain.nextSigninPage',
    defaultMessage: 'Faster sign-in pages (Next.js SSR)',
  },
  experimentalTogglesDisclaimer: {
    id: 'hub.settings.customDomain.experimentalTogglesDisclaimer',
    defaultMessage:
      "These settings can break your hub. Do not change, unless you know what you're doing.",
  },
  postModeratorSentiment: {
    id: 'hub.settings.postModerator.sentiment',
    defaultMessage: 'Sentiment',
  },
  postModerator: {
    id: 'hub.settings.postModerator',
    defaultMessage: 'Moderator',
  },
  postModeratorHeading: {
    id: 'hub.settings.postModerator.heading',
    defaultMessage: 'Post Moderator',
  },
  postModeratorSentimentCheck: {
    id: 'hub.settings.postModerator.sentimentCheck',
    defaultMessage: 'Sentiment Check',
  },
  postModeratorSentimentCheck_hint: {
    id: 'hub.settings.postModerator.sentimentCheck.hint',
    defaultMessage:
      'Allow Hub Member submissions to be identified as positive or negative through text analytics (AI).',
  },
  postModeratorAutoPost: {
    id: 'hub.settings.postModerator.autoPost',
    defaultMessage: 'Auto-post',
  },
  postModeratorAutoPost_hint: {
    id: 'hub.settings.postModerator.autoPost.hint',
    defaultMessage:
      'Allow Hub Member submissions to be approved automatically otherwise, manually approve submitted content.',
  },
  postModeratorPositive: {
    id: 'hub.settings.postModerator.positive',
    defaultMessage: 'Positive',
  },
  postModeratorNeutral: {
    id: 'hub.settings.postModerator.neutral',
    defaultMessage: 'Neutral',
  },
  postModeratorNegative: {
    id: 'hub.settings.postModerator.negative',
    defaultMessage: 'Negative',
  },
  postModeratorNotificationsEnabled: {
    id: 'hub.settings.postModerator.notifications.enabled',
    defaultMessage: 'Submission notifications',
  },
  postModeratorNotificationsEnabled_hint: {
    id: 'hub.settings.postModerator.notifications.enabled.hint',
    defaultMessage: 'Receive notifications from activities on posts.',
  },
  postModeratorNotification_instantly: {
    id: 'hub.settings.postModerator.notifications.instantly',
    defaultMessage: 'Instantly',
  },
  postModeratorNotification_daily: {
    id: 'hub.settings.postModerator.notifications.daily',
    defaultMessage: 'Daily',
  },
  postModeratorNotification_weekly: {
    id: 'hub.settings.postModerator.notifications.weekly',
    defaultMessage: 'Weekly',
  },
  postModeratorNotification_monthly: {
    id: 'hub.settings.postModerator.notifications.monthly',
    defaultMessage: 'Monthly',
  },
  signinOptions: {
    id: 'hub.settings.profile.signinOptions',
    defaultMessage: 'Sign in options',
  },
  signinOptions_hint: {
    id: 'hub.settings.profile.signinOptions.hint',
    defaultMessage: 'If all sign in options are disabled users will see a static landing page.',
  },
  settings: {
    id: 'hub.settings',
    defaultMessage: 'Settings',
  },
  collectionsVisibility: {
    id: 'collections.visibility',
    defaultMessage:
      'If member posts are enabled, member posts will be visible on the “All” page as well as any collection selected.',
  },
  acitivityWidget: {
    id: 'Acitivity.Widget',
    defaultMessage: 'Show activities widget on this collection',
  },
  membersPostToCollection: {
    id: 'members.Post.To.Collection',
    defaultMessage: 'Allow for posts to be made by, and above ',
  },
  collectionSelection: {
    id: 'collection.Selection',
    defaultMessage: 'Only one collection can be selected for member posts.',
  },
  collectionsSubhead: {
    id: 'hub.settings.collections.collections.subheader',
    defaultMessage:
      'The top collection will be the home page of your Hub. Collections will appear in the order listed.',
  },
  archiveSubhead: {
    id: 'hub.settings.collections.archive.subheader',
    defaultMessage: 'These collections will not be visible on the Hub',
  },
  moveUp: {
    id: 'hub.settings.collections.moveup',
    defaultMessage: 'Move Up',
  },
  moveDown: {
    id: 'hub.settings.collections.movedown',
    defaultMessage: 'Move Down',
  },
})
